import { callEndpoint } from 'redux/global';
import { IResponse } from 'types';
import { DB_FETCH_INITIAL_PAGE, dbFetchPageQuery } from 'utils/dbFetchPage';

export const verifyAuth = () => async (dispatch: Function): Promise<IResponse> => {
  const res: IResponse = await dispatch(
    callEndpoint({
      api: 'verify',
      method: 'GET',
    }),
  );
  return res;
};

/** getorganization returns [row]; some cache writes stored the row object itself. */
export const organizationFromGetOrganizationData = (data: unknown) => {
  if (Array.isArray(data) && data[0]) return data[0];
  if (data && typeof data === 'object' && (data as { id?: unknown }).id != null) {
    return data;
  }
  return null;
};

export const getOrganization = (id: string, _forceRefresh = false) => async (
  dispatch: Function,
): Promise<IResponse> => dispatch(
  callEndpoint({
    api: 'getorganization',
    method: 'POST',
    body: { id, page: DB_FETCH_INITIAL_PAGE },
  }),
);

export const getCustomers = (_forceRefresh = false) => async (
  dispatch: Function,
): Promise<IResponse> => dispatch(
  callEndpoint({
    api: `get-customers?${dbFetchPageQuery()}`,
    method: 'GET',
  }),
);
